import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="border-t border-white/5 py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          <Link to="/" className="text-brand font-bold text-lg tracking-tighter flex items-center gap-2">
            <div className="w-5 h-5 bg-brand rounded-sm" />
            CalcBlog
          </Link>
          <div className="flex items-center gap-8 text-[10px] font-bold text-slate-500 uppercase tracking-widest">
            <Link to="/aboutus" className="hover:text-white transition-colors">About Us</Link>
            {/*
            <Link to="/privacy" className="hover:text-white transition-colors">Privacy</Link>
            <Link to="/status" className="hover:text-white transition-colors">System Status</Link>
            */}
          </div>
        </div>
        <div className="mt-12 text-[10px] text-slate-600 font-mono flex items-center justify-between">
          <span>© {new Date().getFullYear()} CALCBLOG. ENGINEERED FOR PERFORMANCE. DRIVEN BY CLARITY.</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;